import React, { useState } from "react";
import PropTypes from "prop-types";

import { Dimmer, Loader } from "semantic-ui-react";

import { ConfirmationModal } from "components/ConfirmationModal";

import { InfoComposer } from "./component";

export function MergeConfirmationModal({
  title,
  sourceClient,
  targetClient,
  notMergeables,
  loading,
  onCancel,
  onMerge,
}) {
  const [isConfirmed, setConfirmed] = useState(notMergeables.length === 0);

  return (
    <Dimmer active={loading} page={loading}>
      <Loader active={loading} />
      <ConfirmationModal
        title={title}
        icon="code branch"
        buttons={[
          {
            id: "cancel-button",
            text: "Cancel",
            callBack: onCancel,
          },
          {
            id: "merge-button",
            text: "Merge",
            color: "green",
            disabled: !isConfirmed,
            callBack: () => {
              if (isConfirmed) onMerge();
            },
          },
        ]}
      >
        <p>
          Are you sure you want to merge {sourceClient} into {targetClient}?
        </p>
        {notMergeables.length > 0 && (
          <React.Fragment>
            <ConfirmationModal.Checkbox
              name="ack"
              info={<InfoComposer info={notMergeables} />}
              onChange={() => {
                setConfirmed((prevState) => {
                  return !prevState;
                });
              }}
            >
              <b>
                I acknowledge that this Client card will be removed and the
                following data will not be accessible
              </b>
            </ConfirmationModal.Checkbox>

            <ul>
              {notMergeables.map((e) => {
                return <li key={e.key}>{e.label}</li>;
              })}
            </ul>
          </React.Fragment>
        )}
      </ConfirmationModal>
    </Dimmer>
  );
}

MergeConfirmationModal.propTypes = {
  title: PropTypes.string,
  loading: PropTypes.bool,
  sourceClient: PropTypes.string.isRequired,
  targetClient: PropTypes.string.isRequired,
  notMergeables: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
  onCancel: PropTypes.func.isRequired,
  onMerge: PropTypes.func.isRequired,
};

MergeConfirmationModal.defaultProps = {
  title: "Merge Contact",
  notMergeables: [],
  loading: false,
};

export default MergeConfirmationModal;
